import React from 'react';
import PropTypes from 'prop-types';

const UserSearchMessage = props => (
  <li className="user-message error">{props.errorMessage}</li>
);

UserSearchMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export default UserSearchMessage;
